var exports = {
  "P": "MentionRenderer.module__label___dlJhcG",
  "p": "MentionRenderer.module__channelIcon___dlJhcG",
};

module.exports = exports;
